// Monogramme VT — logo officiel venteaterme.fr
// Palette : navy #1B2A41 + gold #C9A227, serif Playfair

export function LogoMark({ size = 40, className = "" }) {
  // Icône seule (favicon, avatar, sceau) — cercle + monogramme VT
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} xmlns="http://www.w3.org/2000/svg" aria-label="venteaterme.fr">
      <circle cx="32" cy="32" r="30" fill="none" stroke="#1B2A41" strokeWidth="2" />
      <text x="32" y="42" textAnchor="middle" fontFamily="'Playfair Display', Georgia, serif" fontSize="30" fontWeight="600" fill="#1B2A41">
        V<tspan fill="#C9A227">T</tspan>
      </text>
    </svg>
  );
}

export function LogoHorizontal({ height = 40, className = "", darkMode = false }) {
  // Version horizontale (header, footer, og:image)
  const nav = darkMode ? "#F7F5F0" : "#1B2A41";
  const gold = "#C9A227";
  return (
    <svg viewBox="0 0 300 64" height={height} className={className} xmlns="http://www.w3.org/2000/svg" aria-label="venteaterme.fr">
      <circle cx="32" cy="32" r="30" fill="none" stroke={nav} strokeWidth="2" />
      <text x="32" y="42" textAnchor="middle" fontFamily="'Playfair Display', Georgia, serif" fontSize="30" fontWeight="600" fill={nav}>
        V<tspan fill={gold}>T</tspan>
      </text>
      <line x1="72" y1="18" x2="72" y2="46" stroke={gold} strokeWidth="1" />
      <text x="84" y="34" fontFamily="'Playfair Display', Georgia, serif" fontSize="22" fontWeight="500" fill={nav}>venteaterme</text>
      <text x="84" y="50" fontFamily="'Manrope', system-ui, sans-serif" fontSize="9" letterSpacing="3" fill={nav} opacity="0.75">VENTE À TERME · FR</text>
    </svg>
  );
}
